import $ from 'jquery';

export default class Gravatar {
  constructor($gravatar) {
    const $gravatarFallback = $('.js-gravatar-fallback');

    $gravatar.on('error', () => {
      $gravatarFallback.removeClass('hide');
      $gravatar.remove();
    });

    $gravatar.attr('src', $gravatar.data('gravatar'));
  }
}
